import notify from '../../api/notification'
import patientService from '../../api/patient'
import {
  PATIENT_UPDATE_LIST,
  PATIENT_STATUS
} from '../types'

const state = {
  patients: [],
  patientStatus: 'STATUS_INITIAL'
}

const mutations = {
  [PATIENT_UPDATE_LIST] (state, data) {
    state.patients = data
  },
  [PATIENT_STATUS] (state, status) {
    state.patientStatus = status
  }
}

const getters = {
  patientList: state => {
    return state.patients
  },
  patientIsLoading: state => {
    return state.patientStatus === 'LOADING'
  }
}

const actions = {
  patientGetAll: ({commit}) => {
    commit(PATIENT_STATUS, 'LOADING')
    return patientService
      .getPatients()
      .then((res) => {
        if (res.status === 200) {
          let items = res.data
          items = items.map((patient) => {
          // normalize doctors list
            let doctors = patient.doctor_list.map((doctor) => {
              return {
                id: doctor.id_doctor,
                name: doctor.name,
                crm: doctor.crm,
                uf: doctor.uf
              }
            })

            let birthDate = ''
            // normalize the date
            if (patient.birthdate) {
              birthDate = patient.birthdate
              let date = birthDate.substr(8, 2)
              let month = birthDate.substr(5, 2)
              let year = birthDate.substr(0, 4)
              birthDate = date + '/' + month + '/' + year
            }

            let cpf = ''
            // normalize the cpf
            if (patient.cpf) {
              cpf = patient.cpf
              cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            }

            // return normalized patient
            return {
              id: patient.id_patient,
              name: patient.name,
              cpf,
              birthDate,
              email: patient.email,
              gender: patient.gender === 'M' ? 'Masculino' : 'Feminino',
              status: patient.status,
              showDetail: false,
              doctors
            }
          })
          commit(PATIENT_UPDATE_LIST, items)
          commit(PATIENT_STATUS, 'STATUS_INITIAL')
        }
      })
      .catch(() => {
        commit(PATIENT_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar pacientes.'
        })
      })
  },
  patientDelete: ({commit, state}, item) => {
    commit(PATIENT_STATUS, 'LOADING')
    return patientService
      .deletePatient(item.id)
      .then(() => {
        let items = state.patients
        items = items.filter((obj) => {
          return obj.id !== item.id
        })
        commit(PATIENT_UPDATE_LIST, items)
        commit(PATIENT_STATUS, 'STATUS_INITIAL')
        notify({
          message: 'Paciente excluído com sucesso!'
        })
      })
      .catch(() => {
        commit(PATIENT_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao deletar paciente.'
        })
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
